import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { ImportantNotice } from './ImportantNotice';
import { CourseInfo } from './CourseInfo';
import { SchedulePricing } from './SchedulePricing';
import { ArcheryManager } from './ArcheryManager';
import { QuickLinks } from './QuickLinks';
export function ArcheryPage() {
  return <PageLayout data-id="element-323">
      <HeaderBanner data-id="element-324" />
      <ImportantNotice data-id="element-325" />
      <CourseInfo data-id="element-326" />
      <SchedulePricing data-id="element-327" />
      <ArcheryManager data-id="element-328" />
      <QuickLinks data-id="element-329" />
    </PageLayout>;
}